import { defineComponent as h, computed as l, createBlock as m, openBlock as p, unref as s, normalizeClass as g, normalizeStyle as v, createSlots as O, withCtx as o, createCommentVNode as w, renderSlot as a, createVNode as E } from "vue";
import { JSONtoNaiveVars as i } from "./highrise343.mjs";
import "./highrise59.mjs";
import { TOOLTIP_HEADER_STYLES as N, TOOLTIP_CONTENT_STYLES as L, createTooltipTheme as _, TOOLTIP_STYLE_OVERRIDES as C } from "./highrise610.mjs";
import { COMPONENT_NAME as k } from "./highrise178.mjs";
import $ from "./highrise611.mjs";
import u from "./highrise84.mjs";
const b = h({
  name: k.TOOLTIP,
  inheritAttrs: !1
}), R = /* @__PURE__ */ h({
  ...b,
  props: {
    trigger: { default: "hover" },
    placement: { default: void 0 },
    show: { type: Boolean, default: void 0 },
    variant: { default: "light" },
    headerStyle: { default: () => ({}) },
    contentStyle: { default: () => ({}) },
    tooltipStyle: { default: () => ({}) },
    disabled: { type: Boolean }
  },
  emits: ["show"],
  setup(f) {
    const t = f, y = l(() => ({
      ...N,
      ...t.headerStyle
    })), c = l(() => ({
      ...L,
      ...t.contentStyle
    })), S = l(() => ({
      ...i(C),
      ...i(_(t.variant)),
      ...i(t.tooltipStyle)
    })), T = l(() => ({
      "hr-tooltip": !0,
      "hr-tooltip--light": t.variant === "light",
      "hr-tooltip--dark": t.variant === "dark"
    }));
    return (e, n) => {
      var d;
      return p(), m(s($), {
        trigger: e.trigger,
        show: e.show,
        placement: e.placement,
        "header-style": y.value,
        "content-style": c.value,
        style: v(S.value),
        class: g(T.value),
        disabled: e.disabled,
        "onUpdate:show": n[0] || (n[0] = (r) => e.$emit("show", r))
      }, O({
        trigger: o(() => [
          a(e.$slots, "trigger")
        ]),
        default: o(() => {
          var r;
          return [
            (r = e.$slots) != null && r.default ? (p(), m(s(u), {
              key: 0,
              size: "sm",
              weight: "medium",
              class: "hr-tooltip__content"
            }, {
              default: o(() => [
                a(e.$slots, "default")
              ]),
              _: 3
            })) : w("", !0)
          ];
        }),
        _: 2
      }, [
        (d = e.$slots) != null && d.header ? {
          name: "header",
          fn: o(() => [
            E(s(u), {
              size: "sm",
              weight: "semibold"
            }, {
              default: o(() => [
                a(e.$slots, "header")
              ]),
              _: 3
            })
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["trigger", "show", "placement", "header-style", "content-style", "style", "class", "disabled"]);
    };
  }
});
export {
  R as default
};
